import React, { createContext, useMemo, useState, useEffect } from 'react';

const initialState = {
  searchValues: {},
  setSearchValues: () => {},
  reset: () => {},
};

const initialSearchValues = {
  admin: { state: '', text: '', type: '' },
  org: { state: '', text: '', type: '' },
  branch: { state: '', text: '', type: '' },
  unit: { state: '', text: '', type: '' },
  dep: { state: '', text: '', type: '' },
};

export const ContextSearch = createContext(initialState);

const SearchProvider = ({ children }) => {
  // Carrega valores iniciais do localStorage
  const getInitialValues = () => {
    try {
      const savedFilters = JSON.parse(localStorage.getItem('filters') || '{}');
      return {
        admin: { ...initialSearchValues.admin, ...savedFilters.admin },
        org: { ...initialSearchValues.org, ...savedFilters.org },
        branch: { ...initialSearchValues.branch, ...savedFilters.branch },
        unit: { ...initialSearchValues.unit, ...savedFilters.unit },
        dep: { ...initialSearchValues.dep, ...savedFilters.dep },
      };
    } catch (error) {
      console.error('Erro ao carregar filtros do localStorage:', error);
      return initialSearchValues;
    }
  };

  const [searchValues, setSearchValuesState] = useState(getInitialValues());

  // Sincroniza com localStorage sempre que searchValues mudar
  useEffect(() => {
    try {
      localStorage.setItem('filters', JSON.stringify(searchValues));
    } catch (error) {
      console.error('Erro ao salvar filtros no localStorage:', error);
    }
  }, [searchValues]);

  const setSearchValues = (pageName, value) => {
    if (typeof pageName === 'string') {
      if (typeof value === 'object' && value !== null) {
        // Se value é um objeto, atualiza todos os campos da página
        setSearchValuesState(prev => ({
          ...prev,
          [pageName]: {
            ...prev[pageName],
            ...value
          }
        }));
      } else {
        // Se value é uma string, atualiza apenas o texto da página específica
        setSearchValuesState(prev => ({
          ...prev,
          [pageName]: {
            ...prev[pageName],
            text: value
          }
        }));
      }
    } else {
      // Se pageName é um valor direto (compatibilidade com código antigo)
      setSearchValuesState(prev => ({
        ...prev,
        admin: {
          ...prev.admin,
          text: pageName
        }
      }));
    }
  };

  const clearPageFilters = (pageName) => {
    setSearchValuesState(prev => ({
      ...prev,
      [pageName]: { state: '', text: '', type: '' }
    }));
  };

  const reset = () => {
    setSearchValuesState(initialSearchValues);
  };

  const exportData = useMemo(
    () => ({
      searchValues,
      setSearchValues,
      clearPageFilters,
      reset,
    }),
    [searchValues, setSearchValues, clearPageFilters]
  );

  return (
    <ContextSearch.Provider value={exportData}>
      {children}
    </ContextSearch.Provider>
  );
};

export default SearchProvider;
